import m0 from "views/_hidden";
import m1 from "views/addmenu";
import m2 from "views/compact/sidemenu";
import m3 from "views/roles/details";
import m4 from "views/roles/editor";
import m5 from "views/roles/form";
import m6 from "views/roles/grid";
import m7 from "views/roles/index.js";
import m8 from "views/roles/matrix";
import m9 from "views/roles/members";
import m10 from "views/roles/rules";
import m11 from "views/roles/toolbar";
import m12 from "views/rules/details";
import m13 from "views/rules/index.js";
import m14 from "views/sections/toolbar";
import m15 from "views/sections/view";
import m16 from "views/sidebar";
import m17 from "views/top";
import m18 from "views/topbar";
import m19 from "views/users/audit";
import m20 from "views/users/credentials";
import m21 from "views/users/details";
import m22 from "views/users/editor";
import m23 from "views/users/form";
import m24 from "views/users/grid";
import m25 from "views/users/index.js";
import m26 from "views/users/matrix";
import m27 from "views/users/roles";
import m28 from "views/users/rulematrix";
import m29 from "views/users/rules";
import m30 from "views/users/toolbar";
import { JetView } from "webix-jet";

const views = { JetView };
views["_hidden"] = m0;
views["addmenu"] = m1;
views["compact/sidemenu"] = m2;
views["roles/details"] = m3;
views["roles/editor"] = m4;
views["roles/form"] = m5;
views["roles/grid"] = m6;
views["roles"] = m7;
views["roles/matrix"] = m8;
views["roles/members"] = m9;
views["roles/rules"] = m10;
views["roles/toolbar"] = m11;
views["rules/details"] = m12;
views["rules"] = m13;
views["sections/toolbar"] = m14;
views["sections/view"] = m15;
views["sidebar"] = m16;
views["top"] = m17;
views["topbar"] = m18;
views["users/audit"] = m19;
views["users/credentials"] = m20;
views["users/details"] = m21;
views["users/editor"] = m22;
views["users/form"] = m23;
views["users/grid"] = m24;
views["users"] = m25;
views["users/matrix"] = m26;
views["users/roles"] = m27;
views["users/rulematrix"] = m28;
views["users/rules"] = m29;
views["users/toolbar"] = m30;

export default views;
